import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatChipsModule } from '@angular/material/chips'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatListModule } from '@angular/material/list'

import { ChipsSelectorModule } from '../chips-selector'
import { ProductsSelectorInputComponent } from './products-selector.component'
import { ProductsSelectorDialogComponent } from './products-selector-dialog.component'

@NgModule({
  imports: [
    CommonModule,
    ChipsSelectorModule,
    FlexLayoutModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatListModule,
    ReactiveFormsModule,
  ],
  declarations: [
    ProductsSelectorInputComponent,
    ProductsSelectorDialogComponent,
  ],
  exports: [ProductsSelectorInputComponent],
})
export class ProductsSelectorModule {}
